import { FaYoutube } from "react-icons/fa6";
import { ImFacebook2 } from "react-icons/im";
import { ImLinkedin } from "react-icons/im";
import { FaInstagramSquare } from "react-icons/fa";
// import { domain } from "../../constants/generalConstant";
// import { FaSquareXTwitter } from "react-icons/fa6";

export const upperFooterData = [
  // {
  // 	title: "Our Divisions",
  // 	id: 1,
  // 	subData: [
  // 		{ urlTitle: `${domain} Global Forwarding`, url: "/", id: 1 },
  // 		{ urlTitle: `${domain} Express`, url: "/", id: 2 },
  // 		{ urlTitle: "Other Global Divislion", url: "/", id: 3 },
  // 	],
  // },

  {
    title: "Quick Links",
    id: 1,
    subData: [
      { urlTitle: "Home", url: "/", id: 1 },
      { urlTitle: "About", url: "/about-us", id: 2 },
      { urlTitle: "Services", url: "/service", id: 3 },
      { urlTitle: `FAQs`, url: "/faqs", id: 4 },
      { urlTitle: "Contact Us", url: "/contact-us", id: 5 },
    ],
  },

  // {
  // 	title: "Company information",
  // 	id: 3,
  // 	subData: [
  // 		{ urlTitle: `${domain}`, url: "/", id: 1 },
  // 		{ urlTitle: "Delivered", url: "/", id: 2 },
  // 		{ urlTitle: "Careers", url: "/", id: 3 },
  // 		{ urlTitle: "Press Center", url: "/", id: 4 },
  // 		{ urlTitle: "Investor", url: "/", id: 5 },
  // 		{ urlTitle: "Sustainability", url: "/", id: 6 },
  // 		{ urlTitle: "Brand Partnership", url: "/", id: 7 },
  // 	],
  // },
];

export const lowerFooterdata = [
  { title: "Terms of Use", url: "", id: 1 },
  // { title: "Legal Notice", url: "", id: 2 },
  // { title: "Fraud Awareness", url: "", id: 3 },
  // { title: "Privacy Notice", url: "", id: 4 },
  // { title: "Dispute Resolution", url: "", id: 5 },
  // { title: "Additional Information", url: "", id: 6 },
  // { title: "Cookie Settings", url: "", id: 7 },
];

export const footerSocials = [
  {
    url: "youtube-url",
    icon: <FaYoutube />,
    id: 1,
  },
  {
    url: "youtube-url",
    icon: <ImFacebook2 />,
    id: 2,
  },
  {
    url: "youtube-url",
    icon: <ImLinkedin />,
    id: 3,
  },
  {
    url: "youtube-url",
    icon: <FaInstagramSquare />,
    id: 4,
  },
  // {
  // 	url: "youtube-url",
  // 	icon: <FaSquareXTwitter />,
  // 	id: 5,
  // },
];
